import { render, staticRenderFns } from "./footer.html?vue&type=template&id=5db2b7ba&scoped=true&"
import script from "./footer.js?vue&type=script&lang=js&"
export * from "./footer.js?vue&type=script&lang=js&"
import style0 from "./footer.css?vue&type=style&index=0&id=5db2b7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2b7ba",
  null
  
)

export default component.exports